import { getTargetElements } from "./utils.js";
import { isFunction } from "../utils/index.js";
function importWhenVisible(fn, nameOrSelectorOrElement, parent, observerOptions = {}) {
  let ResolvedClass;
  const resolver = (resolve, cb) => {
    fn().then((module) => {
      ResolvedClass = "default" in module ? module.default : module;
      resolve(ResolvedClass);
      if (isFunction(cb)) {
        cb();
      }
    });
  };
  return new Promise((resolve) => {
    const observer = new IntersectionObserver((entries) => {
      const someEntriesAreVisible = entries.some((entry) => entry.isIntersecting);
      if (someEntriesAreVisible) {
        setTimeout(() => {
          resolver(resolve, () => observer.disconnect());
        }, 0);
      }
    }, observerOptions);
    const elements = getTargetElements(nameOrSelectorOrElement, parent == null ? void 0 : parent.$el);
    elements.forEach((element) => observer.observe(element));
  });
}
export {
  importWhenVisible as default
};
